import { Icon } from 'shared/ui'
import styles from './styles.less'

export default function SideBarHeaderView({ onClose, children }) {
  return (
    <div className={styles.header}>
      <span className={styles['header-body']}>{children}</span>

      <a onClick={onClose} className={styles['header-close']}>
        <Icon name="close" color="white" />
      </a>
    </div>
  )
}
